class DeliveryChecker extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('[data-delivery-checker-form]');
    this.input = this.querySelector('[data-delivery-checker-input]');
    this.button = this.querySelector('[data-delivery-checker-button]');
    this.message = this.querySelector('[data-delivery-checker-message]');
    this.result = this.querySelector('[data-delivery-checker-result]');
    this.estimate = this.querySelector('[data-delivery-checker-estimate]');
    this.csvUrl = this.dataset.csvUrl;
    this.records = null;

    if (!this.form || !this.input || !this.button || !this.message || !this.result || !this.estimate || !this.csvUrl) return;

    const savedZip = window.localStorage.getItem('delivery_checker_zip');
    if (savedZip) this.input.value = savedZip;

    this.button.addEventListener('click', (event) => {
      event.preventDefault();
      this.checkAvailability();
    });

    this.input.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter') return;

      event.preventDefault();
      this.checkAvailability();
    });

    this.input.addEventListener('input', () => {
      if (this.input.value.trim() !== '') return;

      this.hideResult();
      this.message.textContent = '';
      this.message.removeAttribute('data-status');
    });
  }

  async checkAvailability() {
    const zip = this.input.value.trim();

    if (!/^\d{6}$/.test(zip)) {
      this.hideResult();
      this.renderMessage('Enter a valid 6 digit PIN code.', 'error');
      return;
    }

    try {
      const records = await this.getRecords();
      const record = records.get(zip);

      if (!record) {
        this.hideResult();
        this.renderMessage('Delivery is not available in your area yet.', 'error');
        return;
      }

      window.localStorage.setItem('delivery_checker_zip', zip);
      this.renderSuccess(record);
    } catch (error) {
      this.hideResult();
      this.renderMessage('Unable to check delivery right now. Please try again.', 'error');
    }
  }

  async getRecords() {
    if (this.records) return this.records;

    const response = await fetch(this.csvUrl, { cache: 'force-cache' });
    if (!response.ok) throw new Error('Delivery CSV unavailable');

    const csv = await response.text();
    this.records = this.parseCsv(csv);
    return this.records;
  }

  parseCsv(csv) {
    const rows = csv
      .trim()
      .split(/\r?\n/)
      .map((row) => row.split(',').map((cell) => cell.trim()));

    const headers = rows.shift();
    const zipIndex = headers.indexOf('zip_code');
    const startIndex = headers.indexOf('delivery_time_start');
    const endIndex = headers.indexOf('delivery_time_end');
    const records = new Map();

    if (zipIndex === -1 || startIndex === -1 || endIndex === -1) {
      throw new Error('Delivery CSV headers are invalid');
    }

    for (const row of rows) {
      const zip = row[zipIndex];
      if (!zip) continue;

      records.set(zip, {
        delivery_time_start: row[startIndex],
        delivery_time_end: row[endIndex],
      });
    }

    return records;
  }

  renderMessage(text, status) {
    this.message.textContent = text;
    this.message.dataset.status = status;
  }

  renderSuccess(record) {
    this.message.textContent = 'Delivery to this product is available in your area!';
    this.message.dataset.status = 'success';
    this.estimate.textContent = `Delivered in ${record.delivery_time_start}-${record.delivery_time_end} Days`;
    this.result.hidden = false;
  }

  hideResult() {
    this.result.hidden = true;
  }
}

if (!customElements.get('delivery-checker')) {
  customElements.define('delivery-checker', DeliveryChecker);
}